/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import ForceAdsWarningIcon from '../icons/ForceAdsWarningIcon'

import styles from './styles'

const ForceAdsWarning = (props) => {
  const [forceAds, setForceAds] = useState(false)

  const users = useSelector(stateSelector => stateSelector.user)
  useEffect(() => {
    if (showWarning()) {
      setForceAds(true)
    }
  }, ['', users.userId])

  const showWarning = () => {
    if (!users.userId) return false
    if (users.currentlySubscribed) return true
    return false
  }

  if (!forceAds) return null

  if (!props.includeText) return <ForceAdsWarningIcon />

  return (
    <div className="ForceAdsWarning">
      <div className="icon-wrapper">
        <ForceAdsWarningIcon />
      </div>
      <span className="force-ads-text">Includes advertisement</span>
      <style jsx>{styles}</style>
    </div>
  )
}

ForceAdsWarning.propTypes = {
  includeText: PropTypes.bool,
}

ForceAdsWarning.defaultProps = {
  includeText: false,
}
export default ForceAdsWarning
